import React, { useState } from 'react';
import Modal from './ui/Modal';
import { RemarkAction } from '../types';

interface RemarkModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: (remarkText: string) => void;
    action: RemarkAction | null;
}

const RemarkModal: React.FC<RemarkModalProps> = ({ isOpen, onClose, onSubmit, action }) => {
    const [remark, setRemark] = useState('');

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (remark.trim()) {
            onSubmit(remark);
            setRemark(''); // Clear after submit
        }
    };

    const title = action === 'Approved' ? 'Approve Task' : 'Decline Task';
    const description = action === 'Approved' 
        ? 'Please provide a brief approval note.' 
        : 'Please provide a reason for declining this task. This will be visible to the operator.';
    const buttonText = action === 'Approved' ? 'Confirm Approval' : 'Confirm Decline';
    const buttonColor = action === 'Approved' ? 'bg-green-600 hover:bg-green-700 focus:ring-green-500' : 'bg-red-600 hover:bg-red-700 focus:ring-red-500';

    return (
        <Modal isOpen={isOpen} onClose={onClose} title={title}>
            <form onSubmit={handleSubmit}>
                <p className="text-sm text-slate-600 mb-4">{description}</p>
                <div>
                    <label htmlFor="remark" className="sr-only">Remark</label>
                    <textarea
                        id="remark"
                        name="remark"
                        rows={4}
                        className="block w-full px-3 py-2 border border-slate-300 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 sm:text-sm"
                        placeholder="Enter your note here..."
                        value={remark}
                        onChange={(e) => setRemark(e.target.value)}
                        required
                    />
                </div>
                <div className="mt-6 flex justify-end gap-3">
                    <button
                        type="button"
                        onClick={onClose}
                        className="px-4 py-2 bg-white border border-slate-300 text-slate-700 font-semibold rounded-lg shadow-sm hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-slate-400"
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        className={`px-4 py-2 text-white font-semibold rounded-lg shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 ${buttonColor}`}
                        disabled={!remark.trim()}
                    >
                        {buttonText}
                    </button>
                </div>
            </form>
        </Modal>
    );
};

export default RemarkModal;
